import React from 'react';
import PhoneInput from 'react-phone-input-2';
import ru from 'react-phone-input-2/lang/ru.json';
import 'react-phone-input-2/lib/style.css';
import classNames from 'classnames';
import styles from './PhoneNumberInput.module.scss';

type PhoneInputProps = {
  id: string;
  name: string;
  value: string;
  title?: string;
  placeholder: string;
  disabled?: boolean;
  errText?: string;
  className?: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  onBlur: (value: boolean) => void;
  isBooking?: boolean;
};

const PhoneNumberInput: React.FC<PhoneInputProps> = ({
  id,
  name,
  value,
  title,
  placeholder,
  disabled,
  errText,
  className,
  onChange,
  onBlur,
  isBooking,
}) => {
  const onBlurInput = () => {
    onBlur && onBlur(true);
  };

  return (
    <div
      className={classNames(styles.phoneInput, {
        [styles.small]: isBooking,
        [styles.error]: errText,
      })}
    >
      {title && (
        <div className={styles.title_wrapper}>
          <p className={styles.title}>{title}</p>
        </div>
      )}
      <PhoneInput
        localization={ru}
        country={'by'} // страна по умолчанию
        // regions={['europe','asia']}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        containerClass={classNames('myPhone', {
          myPhone_error: errText,
          myPhone_disabled: disabled,
        })}
        disabled={disabled}
        inputClass={classNames('inputPhone', {
          inputPhone_error: errText,
          inputPhone_disabled: disabled,
        })}
        onBlur={onBlurInput}
        inputProps={{
          name: name,
          id: id,
          autoComplete: 'tel',
          required: true,
        }}
      />
      {errText && <p className={styles.errText}>{errText}</p>}
    </div>
  );
};

export default PhoneNumberInput;
